import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return (
    <ul className="mb-0 hidden w-full list-none items-center justify-end lg:flex xl:gap-4">
      <HeaderMenu />
    </ul>
  )
}
